export default "__VITE_ASSET__YNG03ws___"